module.exports = __webpack_public_path__ + "img/farmer-moni-logo-01.56207519.png";